const model = {
    submitting: false,
    errors: null,
    baseUnitDetails: null,
    success: false,
};

export default model;
